import { Media, Role, User } from "@apuestes/types"
import { handleAxiosAuthError } from "../session"

const AUTH_LOCAL_STORAGE_KEY = 'apuestes-key-auth'
const getAuth = (): { token: string, user: User & { photo: Media, roles: Array<Role> } } | undefined => {
  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!localStorage || !lsValue) {
    return
  }

  try {
    const auth: { token: string, user: User & { photo: Media, roles: Array<Role> } } = JSON.parse(lsValue) as { token: string, user: User & { photo: Media, roles: Array<Role> } }
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: { token: string, user: User & { photo: Media } }) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers = {
      'Accept': 'application/json',
  }
  axios.interceptors.request.use(
    (config: { headers: { Authorization: string } } ) => {
      const auth = getAuth()
      if (auth && auth.token && !(config as any).url.toString().includes('firebasedynamiclinks')) {
        config.headers.Authorization = `Bearer ${auth.token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: unknown) => response,
    (error: unknown) => {
      handleAxiosAuthError(error)
      return Promise.reject(error)
    },
  )
}

export { getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY }

